// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"6efaa3b2","121":"f6e771e4","194":"f0f80026","472":"3ca223cf","496":"6128b9ba","586":"d8f2788b","672":"cb48461c","699":"6586acdb","849":"27d2c93e","865":"c42bad76","934":"96da817f"}[chunkId] + ".chunk.js";
};